// deploy-pipelines-run-provenance (Wave 2 of deploy-pipelines-detail-redesign) — TargetDriftStatus is a FIXED numeric tri-state shipped by
// the BE (BE/MarketplaceDeveloper.Infrastructures/DAL/Enums/Deployment/TargetDriftStatus.cs) — the JSON
// wire value is the raw integer 0-2 (no JsonStringEnumConverter is registered), mirroring
// PipelineRunStatus's own contract. These values MUST stay in lockstep with the BE enum; any
// unrecognised/unhandled value falls back to Unknown, NEVER InSync (AC-8) — Unknown is 0, the enum's own
// default, so this is true on both sides without extra code.
export const TargetDriftStatus = Object.freeze({
  Unknown: 0,
  InSync: 1,
  Drifted: 2,
});

export default TargetDriftStatus;
